// extracted by mini-css-extract-plugin
export var container = "_5m-0";
export var icon = "_5m-1";
export var text = "_5m-2";